module.exports = __webpack_public_path__ + "static/media/bca.b8d34595.svg";